export default __webpack_public_path__ + "static/media/dinghy_reziseal.1c86a2d0.jpg";